import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import MainDashboard from '../pages/MainDashboard';
import CompanyLogin from '../pages/CompanyLogin';
import BranchLogin from '../pages/BranchLogin';
import CompanyLayout from '../layouts/CompanyLayout';
import CompanyDashboard from '../pages/CompanyDashboard';
import RegisterForm from '../components/company register/RegisterForm';
import ModuleAccess from '../components/company register/moduleaccess';
const companyRoutes = {
  path: '/company-dashboard',
  element: <CompanyLayout />,
  children: [
    {
      index: true,
      element: <CompanyDashboard />
    },
    {
      path: 'branch-login',
      element: <BranchLogin />
    },
    {
      path: 'branch-login',
      element: <BranchLogin />
    },
    { 
      path:'register',
      element:<RegisterForm/>
    },
    {
      path:'moduleaccess',
      element:<ModuleAccess/>
    }
  ]
};

export default companyRoutes;
